import * as React from 'react';
import { InputProps } from '.';
import Input from './Input';
import { FieldRenderProps } from 'react-final-form';

/**
 * Text Area Props
 */
export type TextAreaProps = FieldRenderProps<any, HTMLInputElement> &
	InputProps & {
		rows?: number;
		cols?: number;
	};

/**
 * Component that renders a custom Input component.
 *
 * @class TextArea
 * @extends {(React.Component<TextAreaProps>)}
 */
class TextArea extends React.Component<TextAreaProps> {
	public static defaultProps: Partial<TextAreaProps> = {
		rows: 5,
	};

	public render() {
		return <Input {...this.props} type="textarea" />;
	}
}

export default TextArea;
